/* eslint-disable */
// duplicate
// delete it afterwards

const postMessageToIframe = (message, iframeId, domain, popUpwindow = null) => {
  const iframe = document.getElementById(iframeId);
  if (popUpwindow) {
    popUpwindow.postMessage(message, domain);
  } else if (iframe && iframeId === iframe.id) {
    let iframe = document.getElementById(iframeId);
    let iframeWindow = (iframe && iframe.childNodes.length > 0 ? iframe.childNodes[0] : iframe)
      .contentWindow;
    if (!iframe && !iframeId) {
      return;
    }
    if (iframeWindow) {
      iframeWindow.postMessage(message, domain);
    }
  }
};

export default postMessageToIframe;
